export const textAlignResponsive = { xs: "center", md: "left" };